import React from 'react';
import { millisecondsToSeconds } from '@24i/player-utils';
import { usePlayerTimes, useAdsData } from '@24i/player-utils-react';
import { useTranslation } from 'react-i18next';
import { Button, Title } from './styled';
const SkipAdButton = ({ playerInstance, className, styles }) => {
    const { isAdBreakActive, currentAd, canSkipAd } = useAdsData(playerInstance);
    const { elapsedTime } = usePlayerTimes(playerInstance);
    const { t } = useTranslation(['sott']);
    const skipOffset = (currentAd === null || currentAd === void 0 ? void 0 : currentAd.skipOffset) || Infinity;
    const isSkippable = skipOffset >= 0 && Number.isFinite(skipOffset);
    const skipInSeconds = Math.ceil(millisecondsToSeconds(skipOffset - elapsedTime));
    const innerTitle = canSkipAd || skipOffset <= elapsedTime
        ? t('player.advertisement.skipAds')
        : t('player.advertisement.skip', { count: skipInSeconds });
    return isAdBreakActive && isSkippable ? (React.createElement(Button, { style: styles.button, onClick: (event) => {
            if (canSkipAd)
                playerInstance.skipAd();
            event.stopPropagation();
        }, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, className: `SkipAdButton ${className}`, "data-test": "SkippAdButton", canAlreadyBeSkipped: canSkipAd },
        React.createElement(Title, { style: styles.title, "data-test": "SkippAdButton-Title", className: "SkipAdButton-Title", canAlreadyBeSkipped: canSkipAd }, innerTitle))) : null;
};
SkipAdButton.defaultProps = {
    className: '',
    styles: {
        button: null,
        title: null,
    },
};
export { SkipAdButton };
//# sourceMappingURL=index.js.map